import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "section-heading" }
const _hoisted_3 = { class: "space-y-3" }

import { Badge } from '@/components/ui/badge';

import SlotDetail from './SlotDetail.vue';

interface Props {
  slots: Slot[];
  queue: Queue[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SlotList',
  props: {
    slots: {},
    queue: {}
  },
  emits: ['slotChanged'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

function slotChanged() {
  emit('slotChanged');
}

function busySlotsCount(): number {
  if (!props.slots || !Array.isArray(props.slots)) return 0;
  let counter = 0;
  props.slots.forEach((s) => {
    if (s.connection != null) counter++;
  });
  return counter;
}

return (_ctx: any,_cache: any) => {
  return (__props.slots?.length)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", null, "Подключения", -1)),
          _createVNode(_unref(Badge), { variant: "outline" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(busySlotsCount()) + "/" + _toDisplayString(__props.slots.length), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.slots, (slot) => {
            return (_openBlock(), _createBlock(SlotDetail, {
              key: slot.id,
              "conn-slot": slot,
              queue: __props.queue,
              onSlotChanged: _cache[0] || (_cache[0] = ($event: any) => (slotChanged()))
            }, null, 8, ["conn-slot", "queue"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})